/**
 * @flow
 * @relayHash e9824d4efab5784bde29d698f454deb6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateOrganizationConfigurationInput = {|
  fileSizeLimits?: ?any,
  dueDateWarnings?: ?any,
  navigation?: ?any,
  currencyCode?: ?string,
  currencyExchangeCommission?: ?any,
  dateDisplay?: ?string,
  timeDisplay?: ?string,
  enablePaymentRequestCsv?: ?boolean,
  clientMutationId?: ?string,
|};
export type UpdateOrganizationConfigurationMutationVariables = {|
  input: UpdateOrganizationConfigurationInput
|};
export type UpdateOrganizationConfigurationMutationResponse = {|
  +updateOrganizationConfiguration: ?{|
    +isUpdated: ?boolean,
    +organization: ?{|
      +id: string,
      +configuration: ?any,
      +currencyCode: string,
      +name: string,
      +tierLabel: ?string,
    |},
  |}
|};
export type UpdateOrganizationConfigurationMutation = {|
  variables: UpdateOrganizationConfigurationMutationVariables,
  response: UpdateOrganizationConfigurationMutationResponse,
|};
*/


/*
mutation UpdateOrganizationConfigurationMutation(
  $input: UpdateOrganizationConfigurationInput!
) {
  updateOrganizationConfiguration(input: $input) {
    isUpdated
    organization {
      id
      configuration
      currencyCode
      name
      tierLabel
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateOrganizationConfigurationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateOrganizationConfiguration",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateOrganizationConfigurationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isUpdated",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "organization",
        "storageKey": null,
        "args": null,
        "concreteType": "OrganizationNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "configuration",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "currencyCode",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "tierLabel",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateOrganizationConfigurationMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateOrganizationConfigurationMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateOrganizationConfigurationMutation",
    "id": null,
    "text": "mutation UpdateOrganizationConfigurationMutation(\n  $input: UpdateOrganizationConfigurationInput!\n) {\n  updateOrganizationConfiguration(input: $input) {\n    isUpdated\n    organization {\n      id\n      configuration\n      currencyCode\n      name\n      tierLabel\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8b0628f7f94fec3cd9e56f1835213e9e';
module.exports = node;
